module.exports = __webpack_public_path__ + "static/media/icoSideMenu.53147a9d.svg";